import { FC } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { KidTemplateType } from '../../../../../api/kids/types';
import { cn } from '../../../../../utilities/cn';
import {
  TEMPLATE_BACKGROUND_BY_TYPE,
  TEMPLATE_BORDER_BY_TYPE,
} from '../../../raidr/kidsV2/components/form/templateSelection.utils';
import { formatKidTemplateTypeLabel } from '../templateManagement.constants';

const TemplateTypeChip: FC<{
  templateType: KidTemplateType | string;
  className?: string;
  size?: 'sm' | 'md';
  tooltip?: string | null;
}> = ({ templateType, className, size = 'md', tooltip }) => {
  const typeKey = String(templateType) as KidTemplateType;
  const backgroundColor = TEMPLATE_BACKGROUND_BY_TYPE[typeKey] ?? '#f3f4f6';
  const borderColor = TEMPLATE_BORDER_BY_TYPE[typeKey] ?? '#9ca3af';

  const chip = (
    <span
      className={cn(
        'inline-flex shrink-0 whitespace-nowrap align-middle rounded border font-bold uppercase tracking-wide text-gray-800',
        size === 'sm'
          ? 'px-1.5 py-0.5 text-[10px] leading-none'
          : 'px-2 py-0.5 text-xs leading-tight',
        tooltip && 'cursor-help',
        className,
      )}
      style={{ backgroundColor, borderColor }}
    >
      {formatKidTemplateTypeLabel(typeKey)}
    </span>
  );

  if (!tooltip) return chip;

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      <span className="inline-flex max-w-full cursor-help">{chip}</span>
    </Tooltip>
  );
};

export default TemplateTypeChip;
